import Vue from 'vue'
import App from './App'
import {
    Container,
    Header,
    Aside,
    Main,
    Footer,
    Button,
    Form,
    FormItem,
    Input,
    Select,
    Option,
    Progress,
    Descriptions,
    DescriptionsItem,
    Divider,
    Result,
    Message,
    Upload,
    Dialog,
    Image,
    Row,
    Col,
    Card,
    DatePicker,
    Table,
    TableColumn,
    Pagination,
    Drawer,
    Switch,
    Tag,
    Rate,
    InfiniteScroll,
    Loading,
    Tabs,
    TabPane
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/iconfont/iconfont.css'; // 引入iconfont 图标
import './assets/iconfont/iconfont.js'; // 引入iconfont 图标
// import '../config/index'
// 引入 axios
import axios from 'axios'
import VueRouter from 'vue-router'
import router from "./router";

Vue.prototype.$message = Message;

// 挂载一个自定义属性$http
Vue.prototype.$http = axios

Vue.use(VueRouter)
// 全局配置axios请求根路径(axios.默认配置.请求根路径)
// axios.create({
//   baseURL: "/api",
//   timeout: 5000
// });
axios.defaults.baseURL = "/api"
axios.defaults.timeout = 5000
// axios.defaults.baseURL = 'http://localhost:8082'


// 响应拦截器
axios.interceptors.response.use(res => {
        // 未设置状态码则默认成功状态
        const code = res.data.code;
        // 获取错误信息
        const msg = res.data.msg
        return res.data
    },
    error => {
        let {message} = error;
        if (message == "Network Error") {
            message = "后端接口连接异常";
        } else if (message.includes("timeout")) {
            message = "系统接口请求超时";
        } else if (message.includes("Request failed with status code")) {
            message = "系统接口" + message.substr(message.length - 3) + "异常";
        }
        window.ELEMENT.Message({
            message: message,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)

Vue.config.productionTip = false

Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Button)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Select)
Vue.use(Option)
Vue.use(Progress)
Vue.use(Descriptions)
Vue.use(DescriptionsItem)
Vue.use(Divider)
Vue.use(Result)
Vue.use(Upload)
Vue.use(Dialog)
Vue.use(Image)
Vue.use(Row)
Vue.use(Col)
Vue.use(Card)
Vue.use(DatePicker)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Drawer)
Vue.use(Switch)
Vue.use(Tag)
Vue.use(Rate)
Vue.use(InfiniteScroll)
Vue.use(Loading)
Vue.use(Tabs)
Vue.use(TabPane)

Vue.directive('click-once', {
  bind(el, binding, vnode) {
    let clicked = false;
    el.addEventListener('click', () => {
      if (!clicked) {
        clicked = true;
        binding.value(); // 执行传入指令的方法
        setTimeout(() => {
          clicked = false;
        }, 1000); // 设置 1 秒后可再次点击
      }
    });
  }
});

new Vue({
    router,
    render: h => h(App)
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js